import { ApolloClient, InMemoryCache, ApolloLink, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import AuthService from '../../auth/storage';
import errorInterceptor from '../interceptors';

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_SERVER_URL}/graphql`, // GraphQL server URL
  credentials: 'same-origin',
});

// Add authorization headers
const authLink = setContext((_, { headers }) => {
  const token = AuthService.getToken(); // Get token from cookies

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

// Combine links: auth -> error interceptor -> HTTP link
const link = ApolloLink.from([authLink, errorInterceptor, httpLink]);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

export default client;
